<!--
출고요청 처리
------------------------------------
-->
<template>
    <!-- 모달 -->
    <div class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
            <div uk-grid class="uk-grid-small uk-padding" uk-height-viewport>

                
                <div class="uk-card uk-card-default uk-card-body uk-card-small uk-width-medium">
                    <!-- 대기화면 -->
                    <div v-show="jobState === 'ready'">
                        <p class="uk-text-center uk-text-large">
                            선택한 상품을 출고요청 합니다.
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="jobStart()"
                            >
                                <span uk-icon="icon: play"></span>
                                작업시작
                            </button>
                        </div>

                        
                    </div>


                    <!-- 실행중 -->
                    <div v-show="jobState === 'doing'">
                        <p class="uk-text-center uk-text-danger uk-text-large">
                            작업이 진행중입니다.<br />
                            작업이 종료될때까지 브라우저를 닫지마세요
                        </p>
                    </div>

                    
                    <!-- 완료 -->
                    <div v-show="jobState === 'done'">
                        <p class="uk-text-center uk-text-primary uk-text-large">
                            작업이 완료되었습니다.<br />
                            브라우저를 닫아도 좋습니다.
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="refreshPage()"
                            >
                                <span uk-icon="icon: refresh"></span>
                                현재 페이지 새로고침
                            </button>
                        </div>
                    </div>


                    <!-- 입력값 표시 -->
                    <div v-show="jobState !== 'ready'" class="">
                    </div>

                    

                </div>

                
        
                <div class="uk-width-expand uk-margin-top app-table-normal">
                    <!-- 진행률 -->
                    <div class="uk-text-large uk-text-primary uk-margin-left">
                        {{ successCount }} / {{ targetCount }}
                        <span v-show="failCount > 0" class="uk-text-danger">(실패 : {{ failCount }})</span>
                    </div>
                    <progress id="js-progressbar" class="uk-progress uk-margin-remove" :value="successCount" :max="targetCount" ></progress>


                    <!-- 리스트 -->
                    <table class="uk-table uk-table-small uk-table-middle app-prod-table uk-margin-top">
                        <colgroup>
                            <col style="width: 8rem">

                            <col style="width: 10rem">
                            <col style="width: 16rem">
                            <col style="width: 10rem">

                            <col style="width: 10rem">
                            <col style="width: 30rem">



                            <col>


                        </colgroup>

                        <thead>
                        <tr>

                            <th scope="col" class="uk-text-center">
                                진행상태
                            </th>


                            <th scope="col" class="uk-text-left">
                                센터
                            </th>
                            <th scope="col" class="uk-text-center">
                                회원사
                            </th>
                            <th scope="col" class="uk-text-center">
                                수취인
                            </th>

                            <th scope="col" class="uk-text-center">
                                배송단계
                            </th>
                            <th scope="col" class="uk-text-left">
                                출고보류사유
                            </th>


                            <th scope="col" class="uk-text-left">
                                상품정보
                            </th>


                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="target in jobTargets"
                        >
                            <td class="uk-text-center">
                                <div v-show="target.state === 'ready'" class="uk-text-muted">
                                    대기
                                </div>
                                <div v-show="target.state === 'doing'" class="uk-text-primary">
                                    <span uk-icon="icon: play"></span>
                                    처리중..
                                </div>
                                <div v-show="target.state === 'success'" class="uk-text-success">
                                    <span uk-icon="icon: check"></span>
                                    성공
                                </div>
                                <div v-show="target.state === 'fail'" class="uk-text-danger uk-position-relative">
                                    <span uk-icon="icon: close"></span>
                                    실패
                                    <!-- 작업메세지 -->
                                    <div v-show="target.job_msg" class="uk-alert-danger uk-position-top-left w-30rem m-0 ml-5rem uk-text-left" uk-alert>
                                        <a href class="uk-alert-close" uk-close></a>
                                        {{ target.job_msg }}
                                    </div>
                                </div>



                            </td>


                            <td class="uk-text-left">
                                <img :src="get_region(target.item.region_id).flag16"/>
                                {{ get_region(target.item.region_id).name }}
                            </td>
                            <td class="uk-text-center">
                                <div title="회원사" class="uk-margin-small-bottom">
                                    {{ target.item.user_nick }}
                                </div>
                            </td>
                            <td class="uk-text-center">
                                <div title="수취인">
                                    {{ target.item.name }}
                                </div>
                            </td>

                            <td class="uk-text-center">
                                {{ target.item.state_text }}
                            </td>
                            <td class="uk-text-left" v-nl2br="target.item.shipout_hold_reason">
                            </td>


                            <td class="uk-text-left">
                                <div v-for="prod in target.item.prods"
                                     :key="prod.id"

                                     class="uk-flex uk-flex-left"
                                >
                                    <div class="mr-1rem">
                                        <img class="w-5rem" :src="prod.img_url" />
                                    </div>
                                    <div class="uk-width-expand">
                                        <div>{{ prod.name }}</div>
                                        <div>색상: {{ prod.color }} 사이즈: {{ prod.size }} 수량: {{ prod.amount }}</div>

                                    </div>

                                </div>
                            </td>



                        </tr>

                        </tbody>
                    </table>



                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import workableByOne from '../workable-by-one';
    import regionAble from "../../../common/region-able.vue";

    export default {
        mixins: [
            workableByOne,
            regionAble,
        ],
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            
            return {

                // 입력값-사유
                inputReason: '',

            };
        },
        computed: {
        },
        methods: {
            /**
             * (실제 사용처에서 재정의)
             *
             * 작업시작 준비단계
             * - 값 검증
             * - 컨펌 처리
             * @return boolean
             */
            prepareJobStart() {
                // 컨펌
                return confirm(this.targetCount+' 개 배송을 출고요청합니다. 정말 실행합니까?')

            },

            // 현재페이지 갱신
            refreshPage() {
                $.app.refresh();
            },

            /**
             * getWorkPromise(target)
             * mixin 을 상속받는 컴포넌트에서 정의 필요함.
             * 1개 작업을 실행하는 Promise를 반환함.
             *  - resolve(job_msg) {}
             *  - reject(job_msg) {}
             *
             * @param target 작업대상 (jobTargets 배열의 아이템)
             * @return Promise
             */
            getWorkPromise(target) {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'PATCH',
                        url: '/houses/'+target.item.id+'/shipout-req',
                        data: {
                            _token: this.csrfToken,
                        },
                        dataType: 'json',
                        success: (response, textStatus, jqXHR) => {
                            // rejolve 처리
                            resolve(response.msg);
                            //console.log('resolve : ' + target.item.id + ' / ' + response.msg);

                            // 단계 업데이트
                            target.item.state_text = response.state_text;

                        },
                        alert_error_msg(msg) {
                            // reject 처리
                            reject(msg);
                            //console.log('reject : ' + target.item.id + ' / ' + msg);
                        },
                    };
                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            },


        }
    }
</script>

<style lang="scss" scoped>

</style>